<template>
    <data-table :columns="fields" :items="tableItems" :row-clickable="false" :show-pagination="false">
        <template #description="{ item }">
            <td class="align-middle">
                {{ item.description }}
            </td>
        </template>
        <template v-for="role in roles" :key="`header-${role.name}`" #[`header-${role.name}`]>
            <span class="flex-1 text-center">{{ role.label }}</span>
        </template>
        <template v-for="role in roles" :key="role.name" #[role.name]="{ item }">
            <td class="text-center align-middle">
                <button
                    v-if="editMode && role.editable"
                    :aria-label="`${item.description} for ${role.label}`"
                    :data-permission="item.name"
                    :data-role="role.name"
                    class="cursor-pointer border-0 bg-transparent p-0"
                    type="button"
                    @click="emit('cell-toggle', { permission: item.name, role: role.name })"
                >
                    <cell-indicator :cell="cellState(item, role)" :readonly="!role.editable" />
                </button>
                <cell-indicator v-else :cell="cellState(item, role)" :readonly="!role.editable" />
            </td>
        </template>
    </data-table>
</template>

<script setup>
import { computed } from 'vue';
import DataTable from '@/Components/DataTable.vue';
import CellIndicator from '@/Pages/Users/Permissions/components/CellIndicator.vue';

const props = defineProps({
    permissions: { type: Array, default: () => [] },
    roles: { type: Array, required: true },
    editMode: { type: Boolean, default: false },
    pendingByKey: { type: Object, default: () => ({}) },
});
const emit = defineEmits(['cell-toggle']);

const fields = computed(() => [
    { key: 'description', label: 'Description', sorter: false },
    ...props.roles.map((role) => ({
        key: role.name,
        label: role.label,
        _style: 'width: 100px; white-space: nowrap; text-align: center',
        sorter: false,
    })),
]);

const tableItems = computed(() => ({
    data: props.permissions,
    meta: { total: props.permissions.length },
}));

function cellState(item, role) {
    const key = `${role.name}::${item.name}`;
    const pending = props.pendingByKey[key];
    if (!pending) {
        return item[role.name];
    }
    return pending.cell;
}
</script>
